/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import CreateNewPartner from 'bundles/admin/components/CreateNewPartner';

const styles = {
  container: () => css`
    position: absolute;
    right: 20px;
    top: 85px;
  `,
};

const NewPartnerBar: React.FC = () => {
  return (
    <div css={styles.container}>
      <CreateNewPartner />
    </div>
  );
};

export default NewPartnerBar;
